module.exports = __webpack_public_path__ + "img/image00002.7ce99658.jpeg";